import { c as _c } from "react/compiler-runtime";
import { IconButton, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { VXButtons } from '../buttons/vxButtons';
export const RenameEntityName = t0 => {
  const $ = _c(18);
  const {
    name,
    label,
    onSubmit,
    bold: t1,
    editMode,
    setEditMode,
    focusOnMount: t2
  } = t0;
  const bold = t1 === undefined ? true : t1;
  const focusOnMount = t2 === undefined ? false : t2;
  const [internalEditMode, setInternalEditMode] = useState(editMode || focusOnMount);
  let t3;
  if ($[0] !== editMode || $[1] !== internalEditMode || $[2] !== setEditMode) {
    t3 = () => setEditMode ? editMode : internalEditMode;
    $[0] = editMode;
    $[1] = internalEditMode;
    $[2] = setEditMode;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getEditMode = t3;
  let t4;
  if ($[4] !== setEditMode) {
    t4 = editMode_0 => setEditMode ? setEditMode(editMode_0) : setInternalEditMode(editMode_0);
    $[4] = setEditMode;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const setEditModeWrapper = t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      alignItems: "center",
      gap: "4px"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== label) {
    t6 = label && <Typography className="mr-[20px]">{label}</Typography>;
    $[7] = label;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== bold || $[10] !== getEditMode || $[11] !== name || $[12] !== onSubmit || $[13] !== setEditModeWrapper) {
    t7 = !getEditMode() ? <Stack direction="row" sx={{
      alignItems: "center",
      gap: "8px"
    }}><Typography className={bold ? "font-semibold" : ""}>{name}</Typography><IconButton onClick={() => setEditModeWrapper(true)} data-testid="rename-entity-name-edit-btn"><i className="material-symbols-stylus-outline w-[20px] h-[20px] text-(--mui-palette-text-primary)" /></IconButton></Stack> : <EditEntityName initialName={name} onSubmit={onSubmit} onClose={() => setEditModeWrapper(false)} />;
    $[9] = bold;
    $[10] = getEditMode;
    $[11] = name;
    $[12] = onSubmit;
    $[13] = setEditModeWrapper;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <Stack direction="row" sx={t5}>{t6}{t7}</Stack>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};
export const EditEntityName = t0 => {
  const $ = _c(27);
  const {
    initialName,
    onSubmit,
    onClose
  } = t0;
  const [newName, setNewName] = useState(initialName);
  let t1;
  if ($[0] !== newName) {
    t1 = validateName(newName);
    $[0] = newName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isValid = t1;
  let t2;
  if ($[2] !== newName || $[3] !== onClose || $[4] !== onSubmit) {
    t2 = () => {
      onClose();
      onSubmit(newName);
    };
    $[2] = newName;
    $[3] = onClose;
    $[4] = onSubmit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const approve = t2;
  let t3;
  if ($[6] !== initialName || $[7] !== onClose) {
    t3 = () => {
      onClose();
      setNewName(initialName);
    };
    $[6] = initialName;
    $[7] = onClose;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const cancel = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      alignItems: "center",
      gap: "12px"
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = !isValid;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      htmlInput: {
        "data-testid": "rename-entity-name-input"
      }
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_0 => setNewName(e_0.target.value);
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== approve || $[13] !== cancel || $[14] !== isValid) {
    t8 = e_1 => {
      if (e_1.key === "Enter") {
        e_1.preventDefault();
        e_1.stopPropagation();
        if (isValid) {
          approve();
        }
      } else {
        if (e_1.key === "Escape") {
          e_1.preventDefault();
          e_1.stopPropagation();
          cancel();
        }
      }
    };
    $[12] = approve;
    $[13] = cancel;
    $[14] = isValid;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== newName || $[17] !== t5 || $[18] !== t8) {
    t9 = <TextField autoFocus={true} onFocus={_temp} error={t5} slotProps={t6} value={newName} onChange={t7} onKeyDown={t8} />;
    $[16] = newName;
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  const t10 = !isValid;
  let t11;
  if ($[20] !== approve || $[21] !== cancel || $[22] !== t10) {
    t11 = <VXButtons onApprove={approve} onCancel={cancel} approveDisabled={t10} />;
    $[20] = approve;
    $[21] = cancel;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <Stack direction="row" sx={t4}>{t9}{t11}</Stack>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};
export const validateName = (name = '') => name.trim().length >= 1;
function _temp(e) {
  return e.target.select();
}